
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Combien de temps pour créer un site Internet vitrine ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Combien de temps faut-il pour un site vitrine avec une agence ? Cet article vous explique les délais incompressibles et les éventuels blocages.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Combien de temps pour créer un site Internet vitrine ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Combien de temps faut-il pour un site vitrine avec une agence ? Cet article vous explique les délais incompressibles et les éventuels blocages.",
        },
      ],
    };
  },
};
